<template lang="pug">
    v-layout(row style="height: 100%;")
        v-flex.xs6.pa-1.subheading.font-weight-bold.text-truncate(justify-start) 
            v-tooltip(top)
                span(slot="activator") {{item.name | truncate(30)}}
                span.tooltip-text.subheading {{item.name}}
            br
            div.body-2.upc-area
                span.font-weight-light UPC: {{item.upc_code}} 
                span.font-weight-light COD: {{item.alias_name}}
        v-divider(vertical)
        v-flex.xs2.text-sm-center.pricing-area.subheading.font-weight-bold(justify-center) 
            span(
                v-if="!editPriceMode"
                :class="priceColor") 
                    span {{salePrice | mixFormatCurrency}}
            div(v-else style="height: 40px;")
                v-text-field(
                    prefix="$"
                    box
                    v-model="salePrice"
                    ref="priceInput"
                    @keydown.enter.stop="blur()"
                    @keydown.esc.stop="blur()"
                    @blur="blur()"
                    style="margin-top: -20px;")
        v-divider(vertical)
        v-flex.xs2.text-sm-center.pricing-area.subheading.font-weight-bold(justify-center)
            span {{showDiscount}}
        v-divider(vertical)
        v-flex.xs2.text-sm-center.pricing-area.subheading.font-weight-bold(justify-center)
            span {{subtotal | mixFormatCurrency}}
</template>

<script>
/**
 * Component to show details of an item in the cart items list.
 */
import CurrencyUtils from '@/mixins/CurrencyUtils'
import TextFormatting from '@/mixins/TextFormatting'
export default {
    name: 'sales-cart-details',
    props: {
        /**
         * @description
         * Item to display
         * @type {object}
         */
        item: {
            type: Object,
            default: {},
        },
        idx: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            editPriceMode: false,
        }
    },
    computed: {
        /**
         * @description
         * Formats and show the item's manual discout if it has any.
         * @returns {string}
         */
        showDiscount: function() {
            if (this.item.lineDiscount.percentage_discount)
                return this.item.lineDiscount.percentage_discount + '%'
            if (this.item.lineDiscount.unit_price_discount)
                return '$' + this.item.lineDiscount.unit_price_discount
            return '-'
        },
        replacedPrice() {
            if (this.item.replaced_price && this.item.replaced_price.replaced) {
                return true
            }
            return false
        },
        offerPrice() {
            return this.item.isOffer
        },
        priceColor() {
            if (this.replacedPrice) return { 'purple--text': true }
            if (this.offerPrice) return { 'green--text': true }
        },
        /**
         * @description
         */
        salePrice: {
            get: function() {
                if (this.item.neto) return this.item.altPrice
                if (this.item.replaced_price) return this.item.sale_price
                if (this.item.discounted_price)
                    return this.item.discounted_price
                return this.item.sale_price
            },
            set: function(val) {
                this.$emit('price:replace', val)
                this.$nextTick(() => {
                    this.item.sale_price = val
                })
            },
        },
        subtotal: function() {
            return this.item.altSubtotal || this.item.subtotal
        },
    },
    methods: {
        editPrice() {
            this.editPriceMode = true
            this.$nextTick(() => this.$refs.priceInput.focus())
        },
        blur() {
            this.editPriceMode = false
            this.$nextTick(() => {
                document.getElementById('barcode-scanner-input').focus()
            })
        },
    },
    mixins: [CurrencyUtils, TextFormatting],
}
</script>

<style lang="scss" scoped>
.upc-area {
    margin-top: 3px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.pricing-area {
    padding-top: 14px;
}
</style>
